module.exports = __webpack_public_path__ + "img/noshare.b4724f52.svg";